export default "__VITE_ASSET__8ff25341__"